// form
import { Controller, useFormContext } from 'react-hook-form';
// @mui
import { TextFieldProps } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import dayjs from 'common/@types/dayjs-custom';
import { formatDayjs } from '@common/utils/formatTime';
import { Dayjs } from 'dayjs';

// ----------------------------------------------------------------------

type IProps = {
  name: string;
};

type Props = IProps & TextFieldProps;

export default function RHFDatePicker({ name, value, ...other }: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      defaultValue={value}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <DatePicker
          openTo="day"
          views={['year', 'month', 'day']}
          label={other.label}
          value={dayjs(field.value)}
          onChange={(newValue: Dayjs | null) => {
            field.onChange(newValue ? formatDayjs(newValue) : null);
          }}
          slotProps={{
            textField: {
              fullWidth: true,
              margin: 'normal',
              helperText: error?.message,
              ...other,
            },
          }}
        />
      )}
    />
  );
}
